// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__ZU1vl","avatar":"style_avatar__1JEX5"};